import { GitConstructError } from './errors/git-construct-error';
import { GitError } from './errors/git-error';
import { GitPluginError } from './errors/git-plugin-error';
import { GitResponseError } from './errors/git-response-error';
import { TaskConfigurationError } from './errors/task-configuration-error';
import { CheckRepoActions } from './tasks/check-is-repo';
import { CleanOptions } from './tasks/clean';
import { GitConfigScope } from './tasks/config';
import { grepQueryBuilder } from './tasks/grep';
import { ResetMode } from './tasks/reset';

export {
   CheckRepoActions,
   CleanOptions,
   GitConfigScope,
   GitConstructError,
   GitError,
   GitPluginError,
   GitResponseError,
   ResetMode,
   TaskConfigurationError,
   grepQueryBuilder,
};

// export const api = {
//    CheckRepoActions,
//    CleanOptions,
//    GitConfigScope,
//    GitConstructError,
//    GitError,
//    GitPluginError,
//    GitResponseError,
//    ResetMode,
//    TaskConfigurationError,
//    grepQueryBuilder,
// };
